import React, { useEffect, useState } from "react";
import { get_tipomovimiento_caja } from "../../../../../actions/caja";
import { SelectUi } from "../../../../ui/SelectUi";

export const TipoMovimientoCajaSelect = ({ ...props }) => {
  const [tipoMovimientosCaja, setTipoMovimientosCaja] = useState([]);

  useEffect(() => {
    const OnLoadData = async () => {
      const datos = await get_tipomovimiento_caja();
      setTipoMovimientosCaja(datos);
    };
    OnLoadData();
  }, []);

  return <SelectUi data={tipoMovimientosCaja} {...props} />;
};
